var exports = {
  "kL": "InlineAudioPlayer.module__container___MVpQMX",
  "wx": "InlineAudioPlayer.module__header___MVpQMX",
  "Rr": "InlineAudioPlayer.module__playButton___MVpQMX",
  "CJ": "InlineAudioPlayer.module__playButtonIcon___MVpQMX",
  "sp": "InlineAudioPlayer.module__loadingSpinnerDesktop___MVpQMX",
  "t0": "InlineAudioPlayer.module__spin___MVpQMX",
  "XE": "InlineAudioPlayer.module__fileInfo___MVpQMX",
  "Md": "InlineAudioPlayer.module__fileName___MVpQMX",
  "m$": "InlineAudioPlayer.module__fileNameTruncate___MVpQMX",
  "i_": "InlineAudioPlayer.module__fileExtension___MVpQMX",
  "gM": "InlineAudioPlayer.module__fileMeta___MVpQMX",
  "NE": "InlineAudioPlayer.module__progressSection___MVpQMX",
  "hr": "InlineAudioPlayer.module__progressBar___MVpQMX",
  "Td": "InlineAudioPlayer.module__time___MVpQMX",
  "ne": "InlineAudioPlayer.module__controls___MVpQMX",
  "it": "InlineAudioPlayer.module__controlsLeft___MVpQMX",
  "BT": "InlineAudioPlayer.module__controlsRight___MVpQMX",
  "Wq": "InlineAudioPlayer.module__volumeControl___MVpQMX",
  "hP": "InlineAudioPlayer.module__actionButton___MVpQMX",
  "AA": "InlineAudioPlayer.module__mobileContainer___MVpQMX",
  "xk": "InlineAudioPlayer.module__mobilePlayButton___MVpQMX",
  "S": "InlineAudioPlayer.module__loadingSpinner___MVpQMX",
  "wh": "InlineAudioPlayer.module__mobileContent___MVpQMX",
  "Vg": "InlineAudioPlayer.module__mobileFileInfo___MVpQMX",
  "Yg": "InlineAudioPlayer.module__mobileFileName___MVpQMX",
  "kB": "InlineAudioPlayer.module__mobileFileMeta___MVpQMX",
  "_S": "InlineAudioPlayer.module__mobileContainerActive___MVpQMX",
  "hb": "InlineAudioPlayer.module__mobileProgressContainer___MVpQMX",
  "jw": "InlineAudioPlayer.module__mobileProgressTrack___MVpQMX",
  "lm": "InlineAudioPlayer.module__mobileProgressTrackActive___MVpQMX",
  "$r": "InlineAudioPlayer.module__mobileProgressFill___MVpQMX",
  "LI": "InlineAudioPlayer.module__mobileProgressFillActive___MVpQMX",
  "zr": "InlineAudioPlayer.module__mobileTimestamp___MVpQMX",
};

module.exports = exports;
